module.exports = __webpack_public_path__ + "static/media/image_ellipse3_ICON.a6b84b7c.svg";